import React from "react";
import { Grid } from "@mui/material";
import { useMessageSource } from "react-message-source";
import SuccessImage from "../../../resources/images/swisscom-dis-success-icon.svg";
import ContentFooter from "../../../ui/layout/page/content/footer";
import NavigationBar from "../../../ui/layout/page/content/footer/navigation-bar";
import Image from "../../../ui/widgets/image";
import CustomTypography from "../../../ui/widgets/typography";
import PageContent from "../../../ui/layout/page/content";

export default function DisSuccess({
  next,
  loggedIn,
}: {
  next: () => void;
  loggedIn: boolean;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();
  const messageSuffix = loggedIn ? "-logged-in" : "-not-logged-in";

  return (
    <>
      <PageContent>
        <Grid container spacing={4} alignItems="center">
          <Grid>
            <Image src={SuccessImage} />
          </Grid>
          <Grid>
            <CustomTypography variant="h3">
              {getMessage(`SwisscomDis.success-title${messageSuffix}`)}
            </CustomTypography>
            <CustomTypography variant="body1">
              {getMessage(`SwisscomDis.success-info${messageSuffix}`)}
            </CustomTypography>
          </Grid>
        </Grid>
        <ContentFooter>
          <NavigationBar
            onNext={next}
            nextButtonText={getMessage(
              `SwisscomDis.success-next-button${messageSuffix}`,
            )}
          />
        </ContentFooter>
      </PageContent>
    </>
  );
}
